/**
 * 判断当前环境是否为iFund客户端
 * @returns {boolean} 如果是iFund客户端返回 true，否则返回 false
 * @example
 * ```ts
 * isInIFindApp(); // => true (在iFund客户端内)
 * isInIFindApp(); // => false (在浏览器中)
 * ```
 */
export function isInIFindApp(): boolean {
  if (typeof navigator === "undefined") {
    return false;
  }
  const ua = navigator.userAgent;
  return /ifind/i.test(ua);
}
